import React, { Component } from "react";
import config from "lib/fr-config";
import ContainedCommonButtonView from "presentational/common/ContainedCommonButtonView";
import PaypalSubscribeBtnView from "presentational/membership/PaypalSubscribeBtnView";
import BombCountdownView from "presentational/common/BombCountdownView";
import KorSubscribeBtnView from "presentational/membership/KorSubscribeBtnView";
import CommonModalView from "presentational/common/modals/CommonModalView";
import TXT from "presentational/common/multinational/TXT";
import DateText from "presentational/common/multinational/DateText";
import { getDeviceType } from "lib/deviceInfo";
import { withStyles } from "@material-ui/core/styles";
import { withStore } from "store/storeHandler";
import Typography from "@material-ui/core/Typography";
import styles from "./SubscribeButtonSectionView.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

const fontCss = config.css.fontThickness;
const colorCss = config.css.color;

const FREE_TRIAL_PERIOD = config.membership.freeTrial.duration;

const SubInfoTypography = withStyles({
  root: {
    fontSize: 12
  }
})(Typography);
const MajorPriceTypography = withStyles({
  root: {
    fontSize: 30,
    fontWeight: fontCss.medium,
    lineHeight: 1
  }
})(Typography);
const MinorPriceTypography = withStyles({
  root: {
    fontSize: 12,
    paddingLeft: 5,
    fontWeight: fontCss.medium,
    lineHeight: 1
  }
})(Typography);
const OriginalPriceTypography = withStyles({
  root: {
    fontSize: 20,
    fontWeight: fontCss.medium,
    lineHeight: 1,
    textDecoration: "line-through",
    color: "#999999"
  }
})(Typography);
const PriceInfoTypography = withStyles({
  root: {
    fontSize: 12,
    paddingTop: 5,
    textAlign: "center"
  }
})(Typography);

class SubscribeButtonSectionView extends Component {
  static propTypes = {
    membershipInfo: PropTypes.shape({
      userType: PropTypes.string.isRequired,
      canUseFreeTrial: PropTypes.bool,
      paymentType: PropTypes.oneOf(["freeTrial", "paypal", "portone"]),
      status: PropTypes.oneOf(["activated", "deactivated", "paused"]),
      startTime: PropTypes.string,
      endTime: PropTypes.string,
      nextBillingTime: PropTypes.string,
      endTimeOnCancel: PropTypes.string,
      availableDateOfSubscription: PropTypes.string,

      numOfAllCoupon: PropTypes.number.isRequired,
      numOfPromotionCoupon: PropTypes.number.isRequired,
      numOfReferralCoupon: PropTypes.number.isRequired,
      numOfCouponUnused: PropTypes.number.isRequired,
      numOfCouponUsed: PropTypes.number.isRequired,
      invitedUserCount: PropTypes.number.isRequired
    }),
    priceInfo: PropTypes.shape({
      originalPrice: PropTypes.object.isRequired,
      discountedPrice: PropTypes.object,
      paypalPlanId: PropTypes.string,
      saleEndDate: PropTypes.string,
      validUntil: PropTypes.string.isRequired
    }).isRequired,
    onRequestFreeTrial: PropTypes.func.isRequired,
    onSubscribeViaPaypal: PropTypes.func.isRequired,
    onSubscribeViaPortone: PropTypes.func.isRequired,
    onSubmitUnsubscription: PropTypes.func.isRequired,
    onRequestRefundInfo: PropTypes.func.isRequired,
    onSubmitRefund: PropTypes.func.isRequired,
    isLatestMembershipInfo: PropTypes.func.isRequired,
    catchPortonePaymentError: PropTypes.func.isRequired
  };

  state = {
    buttonTypeOfClicked: null,

    unsubscribeModalOpen: false,
    refundModalOpen: false
  };

  parseMembershipInfo() {
    const { membershipInfo, AppErrorActions } = this.props;
    const {
      userType,
      canUseFreeTrial,
      availableDateOfSubscription,
      paymentType,
      status
    } = membershipInfo;

    if (userType === "basic") {
      if (canUseFreeTrial) {
        return "basicWhoCanFreeTrial";
      } else if (availableDateOfSubscription) {
        return "basicWhoRefunded";
      } else {
        return "basicWhoEndedFreeTrial";
      }
    } else if (userType === "personal") {
      if (paymentType === "freeTrial" && status === "activated") {
        return "personalUsingFreeTrial";
      } else if (paymentType === "paypal") {
        if (status === "activated") {
          return "personalUsingPaypal";
        } else if (status === "deactivated") {
          return "personalUnsubdPaypal";
        } else if (status === "paused") {
          return "personalPausedPaypal";
        }
      } else if (paymentType === "portone") {
        if (status === "activated") {
          return "personalUsingPortone";
        } else if (status === "deactivated") {
          return "personalUnsubdPortone";
        }
      }
    }

    const errObj = Error(`unknown type`);
    errObj.errorValue = { membershipInfo };
    AppErrorActions.setSafeAppError(errObj);
    return null;
  }

  parsePriceInfo() {
    const { priceInfo } = this.props;

    const onSale = !!priceInfo.discountedPrice;

    return {
      onSale,
      original_us_dollar: priceInfo.originalPrice.us_dollar,
      discount_us_dollar: onSale && priceInfo.discountedPrice.us_dollar,
      original_kr_won: priceInfo.originalPrice.kr_won,
      discoun_kr_won: onSale && priceInfo.discountedPrice.kr_won,
      saleEndDate: priceInfo.saleEndDate,
      paypalPlanId: priceInfo.paypalPlanId
    };
  }

  needBtnOfFreeTrialMode() {
    const memType = this.parseMembershipInfo();
    if (
      memType === "basicWhoCanFreeTrial" ||
      memType === "personalUsingFreeTrial"
    ) {
      return true;
    }
    return false;
  }

  getModeOfOptArea() {
    const { membershipInfo } = this.props;
    const { buttonTypeOfClicked } = this.state;

    if (!membershipInfo) return null;

    const memType = this.parseMembershipInfo();
    if (buttonTypeOfClicked === "freeTrial") {
      return memType === "basicWhoCanFreeTrial"
        ? "freeTrialRequest"
        : memType === "personalUsingFreeTrial"
        ? "freeTrialOngoing"
        : null;
    } else if (buttonTypeOfClicked === "personalSub") {
      switch (memType) {
        case "personalUsingPaypal":
        case "personalUsingPortone":
          return "subOngoing";
        case "personalUnsubdPaypal":
        case "personalUnsubdPortone":
          return "subUnsubd";
        case "personalPausedPaypal":
          return "subPaused";
        case "basicWhoRefunded":
          return "subProhibited";
        default:
          return "subRequest";
      }
    }
  }

  getMainButtonGroup() {
    const { membershipInfo } = this.props;
    if (!membershipInfo) return null;

    const memType = this.parseMembershipInfo();
    const modeOfOptArea = this.getModeOfOptArea();

    let needStartSubBtn, needManageSubBtn;
    switch (memType) {
      case "basicWhoCanFreeTrial":
      case "basicWhoRefunded":
      case "basicWhoEndedFreeTrial":
      case "personalUsingFreeTrial":
        needStartSubBtn = true;
        needManageSubBtn = false;
        break;
      case "personalUsingPaypal":
      case "personalUsingPortone":
      case "personalUnsubdPaypal":
      case "personalUnsubdPortone":
      case "personalPausedPaypal":
        needStartSubBtn = false;
        needManageSubBtn = true;
        break;
      default:
        break;
    }

    const freeTrialStartBtn = (
      <ContainedCommonButtonView
        fullWidth
        onClick={this.handleFreeTrialModeBtnClick}
        design={modeOfOptArea === "freeTrialRequest" ? "bold" : "primary"}
      >
        <TXT
          name="btnCommonContained_startFreeTrial"
          input={{ duration: FREE_TRIAL_PERIOD }}
        />
      </ContainedCommonButtonView>
    );

    const freeTrialManageBtn = (
      <ContainedCommonButtonView
        fullWidth
        onClick={this.handleFreeTrialModeBtnClick}
        design={"bold"}
      >
        <TXT name="btnCommonContained_manageFreeTrial" />
      </ContainedCommonButtonView>
    );

    const membershipStartBtn = (
      <ContainedCommonButtonView
        fullWidth
        onClick={this.handleSubscriptionBtnClick}
        design={"bold"}
      >
        <TXT name="btnCommonContained_startMembership" />
      </ContainedCommonButtonView>
    );

    const membershipManageBtn = (
      <ContainedCommonButtonView
        fullWidth
        onClick={this.handleSubscriptionBtnClick}
        design={"bold"}
      >
        <TXT name="btnCommonContained_manageMembership" />
      </ContainedCommonButtonView>
    );

    return (
      <div className={cx("main-btn-group-wrapper")}>
        {/* 프리티어 임시 차단위해 하단 주석처리. */}
        {/* {this.needBtnOfFreeTrialMode() && (
          <span className={cx("membership-btn")}>
            {memType === "basicWhoCanFreeTrial" && freeTrialStartBtn}
            {memType === "personalUsingFreeTrial" && freeTrialManageBtn}
          </span>
        )} */}
        <span className={cx("membership-btn")}>
          {needStartSubBtn && membershipStartBtn}
          {needManageSubBtn && membershipManageBtn}
        </span>
      </div>
    );
  }

  getSubscribeButtonGroup() {
    const {
      membershipInfo,
      priceInfo,
      onSubscribeViaPaypal,
      onSubscribeViaPortone,
      isLatestMembershipInfo,
      catchPortonePaymentError,
      viewerLocation
    } = this.props;
    const { paypalPlanId } = this.parsePriceInfo();
    const modeOfOptArea = this.getModeOfOptArea();
    if (!membershipInfo) return null;

    const subRequestBtnGroup = (
      <div>
        {viewerLocation === "KR" && (
          <KorSubscribeBtnView
            priceInfo={priceInfo}
            onSubscribeViaPortone={onSubscribeViaPortone}
            isLatestMembershipInfo={isLatestMembershipInfo}
            catchPortonePaymentError={catchPortonePaymentError}
            resetButtonType={this.resetButtonType}
          />
        )}
        {viewerLocation !== "KR" && (
          <PaypalSubscribeBtnView
            paypalPlanId={paypalPlanId}
            onSubscribeViaPaypal={onSubscribeViaPaypal}
            isLatestMembershipInfo={isLatestMembershipInfo}
            resetButtonType={this.resetButtonType}
          />
        )}
      </div>
    );

    const subOngoingBtnGroup = (
      <div className={cx("subscription-manage-ongoing-grp")}>
        <div className={cx("unsubscribe-submit-btn")}>
          <ContainedCommonButtonView
            fullWidth
            onClick={this.handleUnsubscribeRequestBtnClick}
            design={"soft"}
          >
            <TXT name="btnCommonContained_unsubscribeMembership" />
          </ContainedCommonButtonView>
        </div>
        <div className={cx("content-row")}>
          <SubInfoTypography>
            <TXT name="wordMembershipDate_membershipEndDate" />
          </SubInfoTypography>
          <SubInfoTypography>
            <DateText
              inputType={"fullDateText"}
              outputType={"outputYMD"}
              fullDateText={membershipInfo.endTimeOnCancel}
            />
          </SubInfoTypography>
        </div>
        <div className={cx("content-row")}>
          <SubInfoTypography>
            <TXT name="wordMembershipDate_membershipNextBillingDate" />
          </SubInfoTypography>
          <SubInfoTypography>
            <DateText
              inputType={"fullDateText"}
              outputType={"outputYMD"}
              fullDateText={membershipInfo.nextBillingTime}
            />
          </SubInfoTypography>
        </div>
      </div>
    );

    const subUnsubdBtnGroup = (
      <div className={cx("subscription-manage-unsubscribed-grp")}>
        <div className={cx("refund-submit-btn")}>
          <ContainedCommonButtonView
            fullWidth
            onClick={this.handleRefundBtnClick}
            design={"soft"}
          >
            <TXT name="btnCommonContained_refund" />
          </ContainedCommonButtonView>
        </div>
        <div className={cx("content-row")}>
          <SubInfoTypography>
            <TXT name="wordMembershipDate_membershipEndDate" />
          </SubInfoTypography>
          <SubInfoTypography>
            <DateText
              inputType={"fullDateText"}
              outputType={"outputYMD"}
              fullDateText={membershipInfo.endTime}
            />
          </SubInfoTypography>
        </div>
      </div>
    );

    const subPausedBtnGroup = (
      <div className={cx("subscription-manage-paused-grp")}>
        <div className={cx("notice-text")}>
          <SubInfoTypography>
            <TXT name="msg_membershipPaused" />
          </SubInfoTypography>
        </div>
      </div>
    );

    const subProhibitedBtnGroup = (
      <div className={cx("subscription-manage-prohibit-grp")}>
        <div className={cx("content-row")}>
          <SubInfoTypography>
            <TXT name="wordMembershipDate_subAvailableDate" />
          </SubInfoTypography>
          <SubInfoTypography>
            <DateText
              inputType={"fullDateText"}
              outputType={"outputYMD"}
              fullDateText={membershipInfo.availableDateOfSubscription}
            />
          </SubInfoTypography>
        </div>
      </div>
    );

    const freeTrialRequestBtnGroup = (
      <div className={cx("free-trial-start-btn-grp")}>
        <ContainedCommonButtonView
          fullWidth
          onClick={this.handleFreeTrialRequestBtnClick}
          design={"primary"}
        >
          <TXT name="btnCommonContained_freeTrialSubmit" />
        </ContainedCommonButtonView>
        <div className={cx("caption-text")}>
          <SubInfoTypography>
            <TXT name="msg_freeTrialDesc" />
          </SubInfoTypography>
        </div>
      </div>
    );

    const freeTrialOngoingBtnGroup = (
      <div className={cx("free-trial-manage-grp")}>
        <div className={cx("content-row")}>
          <SubInfoTypography>
            <TXT name="wordMembershipDate_freeTrialStartDate" />
          </SubInfoTypography>
          <SubInfoTypography>
            <DateText
              inputType={"fullDateText"}
              outputType={"outputYMD"}
              fullDateText={membershipInfo.startTime}
            />
          </SubInfoTypography>
        </div>
        <div className={cx("content-row")}>
          <SubInfoTypography>
            <TXT name="wordMembershipDate_freeTrialEndDate" />
          </SubInfoTypography>
          <SubInfoTypography>
            <DateText
              inputType={"fullDateText"}
              outputType={"outputYMD"}
              fullDateText={membershipInfo.endTime}
            />
          </SubInfoTypography>
        </div>
      </div>
    );

    return (
      <div className={cx("opt-btn-group-wrapper")}>
        {modeOfOptArea === "subRequest" && subRequestBtnGroup}
        {modeOfOptArea === "subOngoing" && subOngoingBtnGroup}
        {modeOfOptArea === "subUnsubd" && subUnsubdBtnGroup}
        {modeOfOptArea === "subPaused" && subPausedBtnGroup}
        {modeOfOptArea === "subProhibited" && subProhibitedBtnGroup}
        {modeOfOptArea === "freeTrialRequest" && freeTrialRequestBtnGroup}
        {modeOfOptArea === "freeTrialOngoing" && freeTrialOngoingBtnGroup}
      </div>
    );
  }

  resetButtonType = () => {
    this.setState({ buttonTypeOfClicked: null });
  };

  handleModalClose = () => {
    this.setState({ unsubscribeModalOpen: false, refundModalOpen: false });
  };

  handleUnsubscribeRequestBtnClick = async () => {
    const { isLatestMembershipInfo } = this.props;
    if (!(await isLatestMembershipInfo())) {
      this.resetButtonType();
      return null;
    }
    this.setState({ unsubscribeModalOpen: true });
  };

  handleUnsubscribeSubmitBtnClick = async () => {
    const {
      isLatestMembershipInfo,
      membershipInfo,
      onSubmitUnsubscription,
      AppErrorActions
    } = this.props;

    if (!(await isLatestMembershipInfo())) {
      this.resetButtonType();
      return null;
    }

    const { paymentType } = membershipInfo;
    switch (paymentType) {
      case "paypal":
      case "portone":
        onSubmitUnsubscription();
        break;
      default:
        const errObj = Error(`wrong paymentType`);
        errObj.errorValue = { paymentType };
        AppErrorActions.setSafeAppError(errObj);
        break;
    }
    this.handleModalClose();
    this.resetButtonType();
  };

  handleFreeTrialRequestBtnClick = async () => {
    const { onRequestFreeTrial, isLatestMembershipInfo } = this.props;
    if (!(await isLatestMembershipInfo())) {
      this.resetButtonType();
      return null;
    }
    onRequestFreeTrial();
  };

  handleFreeTrialModeBtnClick = () => {
    const { buttonTypeOfClicked } = this.state;

    if (buttonTypeOfClicked === "freeTrial") {
      this.resetButtonType();
    } else {
      this.setState({ buttonTypeOfClicked: "freeTrial" });
    }
  };

  handleSubscriptionBtnClick = () => {
    const { buttonTypeOfClicked } = this.state;

    if (buttonTypeOfClicked === "personalSub") {
      this.resetButtonType();
    } else {
      this.setState({ buttonTypeOfClicked: "personalSub" });
    }
  };

  handleRefundBtnClick = async () => {
    const { isLatestMembershipInfo, onRequestRefundInfo } = this.props;

    if (!(await isLatestMembershipInfo())) {
      this.resetButtonType();
      return null;
    }

    const { refundable } = await onRequestRefundInfo();
    if (refundable) {
      this.setState({ refundModalOpen: true });
    }
  };

  handleRefundSubmitBtnClick = async () => {
    const { isLatestMembershipInfo, onSubmitRefund } = this.props;

    if (!(await isLatestMembershipInfo())) {
      this.resetButtonType();
      return null;
    }

    await onSubmitRefund();
    this.handleModalClose();
    this.resetButtonType();
  };

  render() {
    const { unsubscribeModalOpen, refundModalOpen } = this.state;
    const deviceType = getDeviceType();
    const {
      onSale,
      original_us_dollar,
      discount_us_dollar,
      original_kr_won,
      discoun_kr_won,
      saleEndDate
    } = this.parsePriceInfo();

    return (
      <div className={cx("root", deviceType)}>
        <div className={cx("subscription-btn-area")}>
          <div className={cx("price-text-wrapper")}>
            <div className={cx("price-text-main")}>
              {onSale && (
                <div style={{ paddingRight: 10 }}>
                  <OriginalPriceTypography>
                    <TXT
                      name="wordMembershipPrice"
                      input={{
                        us_dollar: original_us_dollar,
                        kr_won: new Intl.NumberFormat("ko-KR").format(
                          original_kr_won
                        )
                      }}
                    />
                  </OriginalPriceTypography>
                </div>
              )}
              <MajorPriceTypography>
                <TXT
                  name="wordMembershipPrice"
                  input={{
                    us_dollar: onSale ? discount_us_dollar : original_us_dollar,
                    kr_won: new Intl.NumberFormat("ko-KR").format(
                      onSale ? discoun_kr_won : original_kr_won
                    )
                  }}
                />
              </MajorPriceTypography>
              <MinorPriceTypography>
                <TXT name="wordMembershipBillingPeriod" />
              </MinorPriceTypography>
            </div>
            <span style={{ display: "flex", alignItems: "flex-end" }}>
              <MajorPriceTypography>{"(=🍔"}</MajorPriceTypography>
              <MinorPriceTypography>
                <TXT name="wordMembershipBillingPeriod" />
              </MinorPriceTypography>
              <MajorPriceTypography>{")"}</MajorPriceTypography>
            </span>
            {onSale && saleEndDate && (
              <div style={{ padding: 5, paddingTop: 10 }}>
                <BombCountdownView isoDateStr={saleEndDate} />
              </div>
            )}
            <PriceInfoTypography>
              <TXT name="msg_membershipBillingDesc" />
            </PriceInfoTypography>
          </div>
          <div className={cx("subscription-btn-grp-wrapper")}>
            {this.getMainButtonGroup()}
            {this.getSubscribeButtonGroup()}
          </div>
        </div>
        <CommonModalView
          open={unsubscribeModalOpen}
          onClose={this.handleModalClose}
          titleText={<TXT name="titleModal_unsubscribe" />}
          contentText={<TXT name="msg_unsubscribeMembership" />}
          firstButtonText={<TXT name="btnModal_cancel" />}
          firstButtonFunc={this.handleModalClose}
          secondButtonText={<TXT name="btnModal_unsubscribe" />}
          secondButtonTextColor={colorCss.colorOfDanger}
          secondButtonFunc={this.handleUnsubscribeSubmitBtnClick}
        />
        <CommonModalView
          open={refundModalOpen}
          onClose={this.handleModalClose}
          titleText={<TXT name="titleModal_refund" />}
          contentText={<TXT name="msg_refund" />}
          firstButtonText={<TXT name="btnModal_cancel" />}
          firstButtonFunc={this.handleModalClose}
          secondButtonText={<TXT name="btnModal_refund" />}
          secondButtonTextColor={colorCss.colorOfDanger}
          secondButtonFunc={this.handleRefundSubmitBtnClick}
        />
      </div>
    );
  }
}

export default withStore({
  stateMap: {
    userDevice: ["viewerLocation"]
  },
  dispatchMap: ["appError"]
})(SubscribeButtonSectionView);
